import React, { useEffect, useState, useContext } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Tab, Tabs, Button } from '@mui/material';
import { toast } from 'react-toastify';
import axios from 'axios';
import TabPanel from '../../../components/TabPanel';

// Components
import Table from './Table';
// API
import { postProductAllocationList } from '../../../api/productAllocationApi';
// CONTEXT
import useAllocationContext from '../context/useAllocationContext';
let cancelRequest;

export default function AllocationDetails() {
  const navigate = useNavigate();
  const { plan } = useContext(useAllocationContext);
  const [activeTab, setActiveTab] = useState(0);

  const [loading, setLoading] = useState(true);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [productAllocations, setProductAllocations] = useState([]);

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleGenerateFilter = async () => {
    try {
      if (cancelRequest) {
        cancelRequest.cancel('request_cancelled');
        toast.dismiss();
      }

      cancelRequest = axios.CancelToken.source();

      setLoading(true);

      const request = {
        plan_id: plan.plan_id,
        team: activeTab === 0 ? 'KASS' : 'SAR',
        month: Number(moment(plan.effectivity_month, 'MMMM').format('M')),
        year: plan.effectivity_year,
      };

      const response = await postProductAllocationList(request, {
        cancelToken: cancelRequest.token,
      });

      const { code, data = [], headers = [] } = response?.data || {};

      if (code === '200') {
        setTableHeaders(headers);
        setProductAllocations(data);
      } else {
        toast.warning('Please wait for data to load before switching teams');
        return;
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        toast.warning('Please wait for data to load before switching teams');
        return;
      }

      console.error('handleGenerateFilter error:', error);

      toast.error(error?.response?.data?.message || error?.message || 'Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGenerateFilter();
  }, [activeTab]);
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid xs={12} sm={12} md={12}>
          <Box sx={{ backgroundColor: '#fff' }} mt={4}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={activeTab} onChange={handleChangeActiveTab} aria-label='team tab'>
                <Tab label='KASS' id='kass' aria-controls='kass' />
                <Tab label='SAR' id='sar' aria-controls='sar' />
              </Tabs>
            </Box>
            <TabPanel value={activeTab} index={activeTab}>
              <Box>
                <Grid container spacing={2}>
                  <Grid md={12}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Button
                        variant='text'
                        color='primary'
                        onClick={() => navigate('/maintenance/product-inventory-balance-v2')}
                        sx={{
                          marginLeft: '10px',
                          marginBottom: '20px',
                          paddingTop: '10px',
                        }}
                      >
                        Go To Product Inventory Balance (ALL MPR)
                      </Button>
                    </Box>
                  </Grid>
                  <Grid md={12}>
                    <Table
                      loading={loading}
                      tableHeaders={tableHeaders}
                      productAllocations={productAllocations}
                    />
                  </Grid>
                </Grid>
              </Box>
            </TabPanel>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
